import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";
import { fmtDuree, fmtNum } from "@/lib/format";
import { Panel } from "@/components/common/Panel";
import { LoadingState, ErrorState, EmptyState } from "@/components/common/States";
import { cn } from "@/lib/utils";

export const ParetoPanel = ({ kind, du, au }) => {
  const isArret = kind === "arrets";
  const { data, isLoading, error, refetch } = useQuery({ queryKey: ["pareto", kind, du, au], queryFn: () => get(`/pareto/${kind}`, { du, au }) });
  const rows = data || [];
  const max = Math.max(...rows.map((r) => (isArret ? r.duree_sec : r.quantite)), 1);
  return (
    <Panel title={isArret ? "Pareto des arrêts" : "Pareto des rejets"} subtitle={`${du} → ${au}`} testId={`pareto-${kind}-panel`} bodyClassName="p-3 space-y-2 max-h-72 overflow-auto">
      {isLoading ? <LoadingState rows={3} /> : error ? <ErrorState error={error} onRetry={refetch} /> : rows.length === 0 ? <EmptyState title="Aucune donnée sur la période" /> : rows.map((r, i) => {
        const v = isArret ? r.duree_sec : r.quantite;
        return (
          <div key={i} data-testid={`pareto-${kind}-row-${i}`} className="text-[11px]">
            <div className="flex items-center justify-between gap-2 mb-0.5">
              <span className="flex items-center gap-1.5 truncate">
                <span className="font-mono text-muted-foreground w-4">{i + 1}.</span>
                <span className="truncate">{isArret ? r.categorie : r.motif}</span>
                {isArret && <span className={cn("font-mono text-[9px] uppercase px-1 border rounded-sm", r.planifie ? "border-amber-500/40 text-amber-400" : "border-red-500/40 text-red-400")}>{r.planifie ? "planifié" : "non planifié"}</span>}
              </span>
              <span className="font-mono shrink-0">{isArret ? fmtDuree(v) : fmtNum(v)}{isArret && r.occurrences != null && <span className="text-muted-foreground"> · {r.occurrences}×</span>} <span className="text-muted-foreground">({r.pct} %)</span></span>
            </div>
            <div className="h-1.5 bg-muted rounded-sm overflow-hidden"><div className={cn("h-full", isArret ? (r.planifie ? "bg-amber-500/80" : "bg-red-500/80") : "bg-orange-500/80")} style={{ width: `${(v / max) * 100}%` }} /></div>
          </div>
        );
      })}
    </Panel>
  );
};
